﻿var WebFont = require('webfontloader');

WebFont.load({
	google: {
		api: 'https://fonts.googleapis.com/css2',
		families: ['Material+Symbols+Outlined:opsz,wght,FILL,GRAD@48,400,0..1,200']
	},
	timeout: 60000
});